// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wYWjufr4ujyLhRCSXpWg {
}
.bVeeBh1BrSEqu6pBNZM5 {
	display: block;
	margin-bottom: 8px;
}
.ypl_l6L35SFsa0g_bkBy {
	display: flex;
	flex-direction: row;
	gap: 8px;
	width: 100%;
	height: 56px;
	padding: 8px;
	background: white;
	border-radius: 12px;
}
.t4yYI_iZhTGbSXJVK5Pu {
	display: flex;
	height: 28px;
	margin: 6px 0 6px 8px;
	border-radius: 14px;
	background: #f3f3f3;
	position: relative;
}
.t4yYI_iZhTGbSXJVK5Pu:hover {
		background: #ececec;
	}
.t4yYI_iZhTGbSXJVK5Pu img {
		width: 28px;
		height: 28px;
	}
.t4yYI_iZhTGbSXJVK5Pu svg {
		margin: 2px 2px 2px 0;
	}
.t4yYI_iZhTGbSXJVK5Pu svg path {
			stroke: black;
		}
.gZ7u6absomcc8bturJil {
	position: absolute;
	width: 158px;
}
.gZ7u6absomcc8bturJil .zkm56apupVKXPXI8h6ga {
		background: white;
		color: black;
		//padding: 8px 16px;
		border-radius: 16px;
		border: 1px solid #f3f3f3;
		opacity: 1;
		width: 244px;
	}
.LLUFEaVXEQCtbpBN3Alz {
	color: white;
	cursor: default;
	display: block;
	background: black;
	border-radius: 12px;
	padding: 2px 12px;
	height: 28px;
	margin-bottom: 2px;
	white-space: nowrap;
}
._fpFgLY239Z3CHyqRrqa {
	color: white;
	margin: 0;
	padding: 0;
	border-radius: 12px;
	background: black;
}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4 {
		height: 40px;
		cursor: default;
		border-radius: 12px;
		list-style: none;
		padding: 6px 12px;
		display: flex;
		justify-content: space-between;
	}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4:hover {
			background: #222222;
		}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4 .mVr0sHYCiAVsNfHMmHkg {
			width: 28px;
			height: 28px;
			position: relative;
		}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4 .mVr0sHYCiAVsNfHMmHkg .LlS3rb18fsiUsIAUE7x4 {
				position: absolute;
				width: 16px;
				height: 16px;
				right: -8px;
				top: -2px;
			}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4 .mVr0sHYCiAVsNfHMmHkg .BJuOs2Tt68M0g9heuYcL {
				width: 28px;
				height: 28px;
			}
._fpFgLY239Z3CHyqRrqa .Jwja1XLkioPHeRaN1ia4 ._ZvK5fTaFPfjs8MtK2QB {
			text-transform: uppercase;
			line-height: 28px;
			color: white;
			cursor: default;
		}
.UdUVWW0XoShHcogI2UG1 {
	width: 100%;
	display: flex;
	gap: 10px;
}
.UwTr69y0amZ5cwMfWjQH {
	display: flex;
	flex-direction: row;
	grid-gap: 4px;
}
.MC818hnYjbFzTvZ40MXQ {
	background-color: var(--gray);
	border-radius: 8px;
	border: 0;
	cursor: pointer;
	padding: 8px 12px;
	white-space: nowrap;
	line-height: 1.5;
	color: var(--black);
}
`, "",{"version":3,"sources":["webpack://./src/components/StakeSelector/StakeSelector.pcss"],"names":[],"mappings":"AAEA;AACA;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,YAAY;CACZ,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AAcnB;AAbC;EACC,mBAAmB;CACpB;AACA;EACC,WAAW;EACX,YAAY;CACb;AACA;EACC,qBAAqB;CAItB;AAHC;GACC,aAAa;EACd;AAGF;CACC,kBAAkB;CAClB,YAAY;AAWb;AATC;EACC,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,YAAY;CACb;AAED;CACC,YAAY;CACZ,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,mBAAmB;CACnB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,iBAAiB;AAmClB;AAlCC;EACC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;CA0B/B;AAzBC;GACC,mBAAmB;EACpB;AACA;GACC,WAAW;GACX,YAAY;GACZ,kBAAkB;EAYnB;AAXC;IACC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;GACV;AACA;IACC,WAAW;IACX,YAAY;GACb;AAED;GACC,yBAAyB;GACzB,iBAAiB;GACjB,YAAY;GACZ,eAAe;EAChB;AAIF;CACC,WAAW;CACX,aAAa;CACb,SAAS;AACV;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,aAAa;AACd;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.selector {\n}\n\n.selector-caption {\n\tdisplay: block;\n\tmargin-bottom: 8px;\n}\n\n.controls {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 8px;\n\twidth: 100%;\n\theight: 56px;\n\tpadding: 8px;\n\tbackground: white;\n\tborder-radius: 12px;\n}\n\n.control-earns {\n\tdisplay: flex;\n\theight: 28px;\n\tmargin: 6px 0 6px 8px;\n\tborder-radius: 14px;\n\tbackground: #f3f3f3;\n\tposition: relative;\n\t&:hover {\n\t\tbackground: #ececec;\n\t}\n\timg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t}\n\tsvg {\n\t\tmargin: 2px 2px 2px 0;\n\t\tpath {\n\t\t\tstroke: black;\n\t\t}\n\t}\n}\n.control-earns-selector {\n\tposition: absolute;\n\twidth: 158px;\n\n\t.control-earns-item-tooltip {\n\t\tbackground: white;\n\t\tcolor: black;\n\t\t//padding: 8px 16px;\n\t\tborder-radius: 16px;\n\t\tborder: 1px solid #f3f3f3;\n\t\topacity: 1;\n\t\twidth: 244px;\n\t}\n}\n.control-earns-selector-caption {\n\tcolor: white;\n\tcursor: default;\n\tdisplay: block;\n\tbackground: black;\n\tborder-radius: 12px;\n\tpadding: 2px 12px;\n\theight: 28px;\n\tmargin-bottom: 2px;\n\twhite-space: nowrap;\n}\n.control-earns-items {\n\tcolor: white;\n\tmargin: 0;\n\tpadding: 0;\n\tborder-radius: 12px;\n\tbackground: black;\n\t.control-earns-item {\n\t\theight: 40px;\n\t\tcursor: default;\n\t\tborder-radius: 12px;\n\t\tlist-style: none;\n\t\tpadding: 6px 12px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\t&:hover {\n\t\t\tbackground: #222222;\n\t\t}\n\t\t.control-earns-item-icon {\n\t\t\twidth: 28px;\n\t\t\theight: 28px;\n\t\t\tposition: relative;\n\t\t\t.control-earns-item-chain {\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 16px;\n\t\t\t\theight: 16px;\n\t\t\t\tright: -8px;\n\t\t\t\ttop: -2px;\n\t\t\t}\n\t\t\t.control-earns-item-token {\n\t\t\t\twidth: 28px;\n\t\t\t\theight: 28px;\n\t\t\t}\n\t\t}\n\t\t.control-earns-item-caption {\n\t\t\ttext-transform: uppercase;\n\t\t\tline-height: 28px;\n\t\t\tcolor: white;\n\t\t\tcursor: default;\n\t\t}\n\t}\n}\n\n.control-amount {\n\twidth: 100%;\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.selector-row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgrid-gap: 4px;\n}\n\n.control-get-lp {\n\tbackground-color: var(--gray);\n\tborder-radius: 8px;\n\tborder: 0;\n\tcursor: pointer;\n\tpadding: 8px 12px;\n\twhite-space: nowrap;\n\tline-height: 1.5;\n\tcolor: var(--black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `wYWjufr4ujyLhRCSXpWg`,
	"selector-caption": `bVeeBh1BrSEqu6pBNZM5`,
	"selectorCaption": `bVeeBh1BrSEqu6pBNZM5`,
	"controls": `ypl_l6L35SFsa0g_bkBy`,
	"control-earns": `t4yYI_iZhTGbSXJVK5Pu`,
	"controlEarns": `t4yYI_iZhTGbSXJVK5Pu`,
	"control-earns-selector": `gZ7u6absomcc8bturJil`,
	"controlEarnsSelector": `gZ7u6absomcc8bturJil`,
	"control-earns-item-tooltip": `zkm56apupVKXPXI8h6ga`,
	"controlEarnsItemTooltip": `zkm56apupVKXPXI8h6ga`,
	"control-earns-selector-caption": `LLUFEaVXEQCtbpBN3Alz`,
	"controlEarnsSelectorCaption": `LLUFEaVXEQCtbpBN3Alz`,
	"control-earns-items": `_fpFgLY239Z3CHyqRrqa`,
	"controlEarnsItems": `_fpFgLY239Z3CHyqRrqa`,
	"control-earns-item": `Jwja1XLkioPHeRaN1ia4`,
	"controlEarnsItem": `Jwja1XLkioPHeRaN1ia4`,
	"control-earns-item-icon": `mVr0sHYCiAVsNfHMmHkg`,
	"controlEarnsItemIcon": `mVr0sHYCiAVsNfHMmHkg`,
	"control-earns-item-chain": `LlS3rb18fsiUsIAUE7x4`,
	"controlEarnsItemChain": `LlS3rb18fsiUsIAUE7x4`,
	"control-earns-item-token": `BJuOs2Tt68M0g9heuYcL`,
	"controlEarnsItemToken": `BJuOs2Tt68M0g9heuYcL`,
	"control-earns-item-caption": `_ZvK5fTaFPfjs8MtK2QB`,
	"controlEarnsItemCaption": `_ZvK5fTaFPfjs8MtK2QB`,
	"control-amount": `UdUVWW0XoShHcogI2UG1`,
	"controlAmount": `UdUVWW0XoShHcogI2UG1`,
	"selector-row": `UwTr69y0amZ5cwMfWjQH`,
	"selectorRow": `UwTr69y0amZ5cwMfWjQH`,
	"control-get-lp": `MC818hnYjbFzTvZ40MXQ`,
	"controlGetLp": `MC818hnYjbFzTvZ40MXQ`
};
export default ___CSS_LOADER_EXPORT___;
